import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import Grid from '@mui/material/Grid2';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import CustomDatePicker from '../../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import dayjs from 'dayjs';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { get_workforce_with_out_pagination } from '../../../../config/Resource/workforceApis';

function CompensationLeaveFilter({ tableTitle, searchFilter, on_change_value, on_page_count_update }) {


    const [workforceListing, setWorkforceListing] = useState([]);

    // FETCH fetchWorkforce
    const fetchWorkforce = async () => {
        try {
            const response = await get_workforce_with_out_pagination();

            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.UD_name,
                    value: item?.UD_ID
                }));

                // Set the transformed data to the state
                setWorkforceListing(transformedData || []);
            } else {
                setWorkforceListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setWorkforceListing([]);
        }
    };

    useEffect(() => {
        fetchWorkforce();
    }, [])

    // Initialize formik for form state management
    const formik = useFormik({
        initialValues: {
            startDate: '',
            endDate: '',
            employeeId: '',

        },
        // onSubmit: (values) => {
        //   searchFilter(values)
        // },
    });

    const resetFilter = () => {

        on_change_value(1)
        on_page_count_update(25)

        formik.setValues({
            startDate: "",
            endDate: "",
            employeeId: '',
        });
        searchFilter({ //FOR UPPDATE THE STATES WHEN RESET CLICK
            startDate: "",
            endDate: "",
            employeeId: '',
        })
    };


    const breadcrumbs = ['leave', tableTitle]

    return (
        <div className="project-lookup-search-container">
            <div className="project-lookup-search-sub-container">
                <div className="project-lookup-search-header">
                    <div className="project-lookup-search-left">
                        <div className="project-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                    <div className="project-lookup-search-right">
                    </div>
                </div>
                <div className="search-layout-wrapper">
                    <div className="search-filter-container">
                        <div className="search-inputs-fields">

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="employeeId"
                                    placeholder="Select Workforce"
                                    options={workforceListing}
                                    value={workforceListing.find((employee) => employee.value === formik.values.employeeId) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("employeeId", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.employeeId && Boolean(formik.errors.employeeId)}
                                    helperText={formik.touched.employeeId && formik.errors.employeeId}
                                    isDisabled={false}
                                    isMulti={false} // Single select
                                    width="200px"
                                />
                            </Grid>


                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="startDate"
                                    label="From Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("startDate", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.startDate ? dayjs(formik.values.startDate, "DD-MM-YYYY") : null}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="endDate"
                                    label="End Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("endDate", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.endDate ? dayjs(formik.values.endDate, "DD-MM-YYYY") : null}
                                    minDate={dayjs(formik.values.startDate, "DD-MM-YYYY")} // Set minimum date
                                    width="200px"
                                />
                            </Grid>

                        </div>

                        {/* Search Button */}
                        <div className="search-buttons-fixed-right">
                            <ActionButton
                                onClick={() => {
                                    on_change_value(1)
                                    searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                                }}
                                btnDisable={false}
                                label="Search"
                                btnType="primary"
                            />
                            <ActionButton label="Reset" btnType="outlined" onClick={resetFilter} />
                        </div>

                    </div>
                </div>


            </div>
        </div>
    );
}

export default CompensationLeaveFilter;
